import type { RaffleFormValues } from "./formValues";

export interface RafflePreview {
  pool: string;
  winners: number;
  perWinner: string;
  balanceAfter: string;
  isOverBalance: boolean;
}

// Пока форма не заполнена, в инпутах может быть что угодно: считаем это нулём.
const toPositive = (value: string): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const getRafflePreview = (
  { prizePool, winnersCount }: RaffleFormValues,
  balance: number,
): RafflePreview => {
  const pool = toPositive(prizePool);
  const winners = Math.floor(toPositive(winnersCount));
  return {
    pool: pool.toFixed(2),
    winners,
    perWinner: (winners ? pool / winners : 0).toFixed(2),
    balanceAfter: (balance - pool).toFixed(2),
    isOverBalance: pool > balance,
  };
};
